export enum status {
   DRAFT = 'draft',
   EMAIL_FAILED ='email failed',
   PENDING = 'pending',
   AWAITING_STUDENT_RESPONSE = "awaiting student response",
   OTHER = "Other"
  }

export enum StatusEnum {
   Declined = "Rejected",
   InReview = "In Review",
   Approved = "Approved",
   Invoice = "In Review",
   Pending = "Awaiting student response",
   StagnantApplication ="Stagnant application",
   EmailFailed = "Email Failed",
   Onboarded = "Onboarded"
 };
